export default __webpack_public_path__ + "static/logo-gold-87de2de0b5fa2d5c3ec70e21b959bc72.svg";